import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["hovered"];
import FormControl from '../../../v2/components/FormControl';
import styled from 'styled-components';
import { getDataAttributes } from '../../../utils/getDataAttributes';
import { HIGHLY_SENSITIVE_MASKED_DISPLAY } from '../../../dataSensitivity/highlySensitiveMaskedDisplay';
import { ShowHighlySensitiveValueButton } from '../../../dataSensitivity/ShowHighlySensitiveValueButton';
import { useHovered } from 'foundations-components/transitional/utils/useHovered';
import FormControlAdapter from '../../../adapters/FormControl';
import { HighlySensitiveDataMaskedDisplay } from '../../../dataSensitivity/HighlySensitiveDataMaskedDisplay';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledDiv = styled.div.withConfig({
  displayName: "PropertyInputHighlySensitiveNonFloating__StyledDiv",
  componentId: "sc-1my359n-0"
})(["display:inline-flex;align-items:center;position:relative;justify-content:center;"]);
const StyledAsteriks = styled.div.withConfig({
  displayName: "PropertyInputHighlySensitiveNonFloating__StyledAsteriks",
  componentId: "sc-1my359n-1"
})(["position:absolute;"]);
export const PropertyInputHighlySensitiveNonFloating = props => {
  const {
    displayOptimized,
    use,
    formControlProps = {},
    inputProps = {}
  } = props;
  const _useHovered = useHovered({}),
    {
      hovered
    } = _useHovered,
    hoveredProps = _objectWithoutPropertiesLoose(_useHovered, _excluded);
  if (displayOptimized) {
    return /*#__PURE__*/_jsx(FormControlAdapter, Object.assign({}, formControlProps, {
      children: /*#__PURE__*/_jsx(HighlySensitiveDataMaskedDisplay, Object.assign({}, inputProps))
    }));
  }
  return /*#__PURE__*/_jsxs(StyledDiv, Object.assign({}, hoveredProps, {
    children: [/*#__PURE__*/_jsx(StyledAsteriks, {
      children: /*#__PURE__*/_jsx(FormControl, Object.assign({}, formControlProps, {
        formControlUse: use,
        children: /*#__PURE__*/_jsx("span", Object.assign({}, getDataAttributes(inputProps), {
          children: HIGHLY_SENSITIVE_MASKED_DISPLAY
        }))
      }))
    }), /*#__PURE__*/_jsx(ShowHighlySensitiveValueButton, {
      isVisible: hovered
    })]
  }));
};